import React, { useEffect, useState } from "react";
import { Row, Col } from "react-bootstrap";
import { Account, AppConfiguration, AuthenticationConstants, Countries, Country, Helpers, LocationService, useAppSelector } from "src/common";
import { Icon, ToolbarButton } from "src/components";
import { ChangePhoneNumber } from ".";
import { RootState } from "src/store/configureStore";
import { parsePhoneNumberFromString, PhoneNumber } from "libphonenumber-js";

const location_service = new LocationService();
function ProfileFormComponent() {
  const is_express = AppConfiguration.buildForExpress();
  const session_pv_account = sessionStorage.getItem(AuthenticationConstants.USER_ID_SESSION_KEY);
  const current_profile = useAppSelector((state: RootState) => state.account.current_account)?.profile;
  const current_account = useAppSelector((state: RootState) => state.account.current_account);
  const [modal_show, setModalShow] = useState<boolean>(false);
  const [country, setCountry] = useState<Country>();
  const [phone_mask, setPhoneMask] = useState<string>();
  const [parsed_number, setParsedNumber] = useState<PhoneNumber>();

  useEffect(() => {
    is_express && getPhoneNumber();
  }, [session_pv_account]);

  async function getPhoneNumber() {
    if (!!session_pv_account && !!current_account) {
      const account_ids = Account.getAccountIdentifiers(current_account);
      const encrypted_contact = JSON.parse(session_pv_account).encrypted_contact;
      const phone_number_bytes = !!encrypted_contact ? await account_ids.user_key.encryption_key.unseal(Helpers.b64Decode(encrypted_contact)) : undefined;
      const phone_number = !!phone_number_bytes ? Helpers.utf8Decode(phone_number_bytes) : undefined;
      const _phone_number = !!phone_number ? parsePhoneNumberFromString(phone_number) : undefined;
      if (!!_phone_number) {
        setParsedNumber(_phone_number);
        setPhoneMask(_phone_number.nationalNumber.toString());
        setCountry(Countries.find((country) => country.country_abb === _phone_number.country));
      }
    }
  }

  return <>
    <h2 className="content-header border-bottom">Name and Email</h2>
    <div className="profile">
      <Row>
        <Col md={4}>Name</Col>
        <Col>{current_profile?.name || ""}</Col>
      </Row>
      <Row>
        <Col md={4}>Email Address</Col>
        <Col>{current_profile?.address || "Email"}</Col>
      </Row>
      {is_express && !!phone_mask && !!country && <Row>
        <Col md={4}>Mobile Phone Number</Col>
        <Col className="change-phone">
          <span className="country-mask">
            <Icon className={`cicon-${country.country_abb.toLowerCase()}`} />
            <span>{country.country_abb}</span>
          </span>
          <span className="phone-code">{country.country_number_code} -</span>
          <div className="phone-input">{location_service.phoneMaskChange(phone_mask)}</div>
          <ToolbarButton onClick={() => setModalShow(true)} ariaLabel="Change Phone Number" tooltipContent="Change Phone Number" tooltipPlace="bottom">
            <Icon className="pv-icon-compose" />
          </ToolbarButton>
          {!!parsed_number && <ChangePhoneNumber modal_show={modal_show} setModalShow={setModalShow} current_phone_number={parsed_number}></ChangePhoneNumber>}
        </Col>
      </Row>}
    </div>
  </>;
}

export default React.memo(ProfileFormComponent);
